
import { computed, defineComponent, PropType } from 'vue'
import { candidateReason, offerButtonLabel, visitsLine } from '../helpers'
import { DayKey, HotWindow, HotWindowCandidate, HotWindowService } from '../types'
import HwIcon from './HwIcon.vue'
import MoveFlow from './MoveFlow.vue'

export default defineComponent({
    name: 'HotWindowsBestCandidate',
    components: { HwIcon, MoveFlow },
    props: {
        candidate: { type: Object as PropType<HotWindowCandidate>, required: true },
        window: { type: Object as PropType<HotWindow>, required: true },
        service: { type: Object as PropType<HotWindowService>, required: true },
        start: { type: Number, required: true },
        dayKey: { type: String as PropType<DayKey>, required: true },
        date: { type: String, required: true },
        position: { type: Number, default: 1 },
        sent: { type: Boolean, default: false },
    },
    emits: ['offer', 'profile', 'skip'],
    setup(props) {
        return {
            reason: computed(() =>
                candidateReason(props.candidate, { start: props.start, referenceDate: props.date })
            ),
            visits: computed(() => visitsLine(props.candidate)),
            offerLabel: computed(() => offerButtonLabel(props.candidate.source)),
        }
    },
})
